import * as React from 'react';

export const useScrolled = (args: { offsetTop: number }) => {
  const [scrolled, setScrolled] = React.useState<boolean>(false);

  const handleScroll = () => {
    if (window.pageYOffset > args.offsetTop) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return [scrolled];
};
